import { useCallback } from "react";

import { useData } from "../context/DataContext";

/**
 * Custom hook to manage the project filter synchronization between Context and LocalStorage.
 * This hook provides a unified way to access and update the active project.
 */
export const useProjectFilter = () => {
  const { globalProjectId, setGlobalProjectId } = useData();

  // Unified Update Function
  const updateProject = useCallback(
    (projectId) => {
      setGlobalProjectId(projectId || "ALL");
    },
    [setGlobalProjectId]
  );

  return {
    projectId: globalProjectId,
    updateProject,
    isAllProjects: globalProjectId === "ALL" || !globalProjectId
  };
};
